module.exports = __webpack_public_path__ + "img/true.b1e8e38b.svg";